import {PopupType} from '@/root/hooks/usePopup';

import {PopupProviderProps} from '@/shared/providers/PopupProvider';

import CardDeleteFailPopup from '@/apps/root/components/popups/CardDeleteFailPopup';
import CardDeletePopup from '@/apps/root/components/popups/CardDeletePopup';
import HomeEventPopup from '@/apps/root/components/popups/HomeEventPopup';
import PapasErrorPopup from '@/apps/root/components/popups/PapasErrorPopup';
import ServerErrorPopup from '@/apps/root/components/popups/ServerErrorPopup';

export const COMPONENT_BY_TYPE: PopupProviderProps<PopupType>['components'] = {
  CARD_DELETE: CardDeletePopup,
  CARD_DELETE_FAIL: CardDeleteFailPopup,
  SERVER_ERROR: ServerErrorPopup,
  PAPAS_ERROR: PapasErrorPopup,
  HOME_EVENT: HomeEventPopup
};
